import { useMutation } from '@tanstack/react-query';
import { useMixpanel } from 'react-mixpanel-browser';

import { refreshCachedDevice } from '@/api/devices';
import { axios } from '@/common/axios';
import { MutationConfig } from '@/common/react-query';
import { useErrorContext } from '@/context/ErrorContext';

export const postCancelModeChange = (payload: { spotterId: string }): Promise<{ status: string }> => {
    return axios.post('/device/cancel-mode-change', payload);
};

type UsePostCancelModeChangeOptions = {
    config?: MutationConfig<typeof postCancelModeChange>;
    data?: { spotterId: string };
};

export const usePostCancelModeChange = ({ config }: UsePostCancelModeChangeOptions = {}) => {
    const { createErrorHandler } = useErrorContext();
    const mixpanel = useMixpanel();
    return useMutation({
        ...config,
        mutationFn: postCancelModeChange,
        onSuccess: (_data, variables) => {
            refreshCachedDevice(variables.spotterId);
            mixpanel?.track('Device data mode change cancelled', {
                spotterId: variables.spotterId,
            });
        },
        onError: createErrorHandler('cancel Spotter data transmission change'),
    });
};
